import { PageLayout, PageLayoutHeader, PageLayoutRow, PageLayoutTitle } from 'components';
import React from 'react';
import * as S from '../app.styles';

export class Redirect extends React.Component {
    private timer: NodeJS.Timeout | null = null;
    public componentDidMount(): void {
        this.timer = setTimeout(this.redirect, 10 * 1000);
    }
    public componentWillUnmount(): void {
        this.timer && clearTimeout(this.timer);
    }
    public render(): React.ReactElement {
        return (
            <S.Section>
                <PageLayout>
                    <PageLayoutRow>
                        <PageLayoutHeader>
                            <PageLayoutTitle>You are being redirected.</PageLayoutTitle>
                        </PageLayoutHeader>
                    </PageLayoutRow>
                </PageLayout>
            </S.Section>
        );
    }
    private redirect(): void {
        window.location.href = '/expired';
    }
}
